import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBarChart4Bars = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-348.44 -348.44 2488.89 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M1024 128H1664V256H1024ZM640 640H1664V768H640ZM1280 1152H1664V1280H1280ZM1792 320V64Q1792 38 1773.0 19.0Q1754 0 1728 0H64Q38 0 19.0 19.0Q0 38 0 64V320Q0 346 19.0 365.0Q38 384 64 384H1728Q1754 384 1773.0 365.0Q1792 346 1792 320ZM1792 832V576Q1792 550 1773.0 531.0Q1754 512 1728 512H64Q38 512 19.0 531.0Q0 550 0 576V832Q0 858 19.0 877.0Q38 896 64 896H1728Q1754 896 1773.0 877.0Q1792 858 1792 832ZM1792 1344V1088Q1792 1062 1773.0 1043.0Q1754 1024 1728 1024H64Q38 1024 19.0 1043.0Q0 1062 0 1088V1344Q0 1370 19.0 1389.0Q38 1408 64 1408H1728Q1754 1408 1773.0 1389.0Q1792 1370 1792 1344Z"
	})
});
export default SvgBarChart4Bars;
